import { cn } from "@/lib/utils";
import ScrollReveal from "./ScrollReveal";

interface SectionHeaderProps {
  label?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  className?: string;
  labelClassName?: string;
  titleClassName?: string;
}

const SectionHeader = ({
  label,
  title,
  description,
  align = "center",
  className,
  labelClassName,
  titleClassName,
}: SectionHeaderProps) => {
  return (
    <ScrollReveal animation="fade-up" className={cn("mb-12 md:mb-16", className)}>
      <div className={cn(align === "center" && "text-center")}>
        {/* Label */}
        {label && (
          <p
            className={cn(
              "text-sm tracking-[0.2em] uppercase text-accent font-semibold mb-3",
              labelClassName
            )}
          >
            {label}
          </p>
        )}

        {/* Title with optional divider */}
        <div className={cn("relative", align === "center" && "flex flex-col items-center")}>
          <h2
            className={cn(
              "font-display text-3xl md:text-4xl lg:text-5xl font-bold",
              titleClassName
            )}
          >
            {title}
          </h2>
          
          {/* Decorative Line */}
          <div className="mt-4 flex items-center gap-2">
            <div className="w-8 h-0.5 bg-gradient-to-r from-transparent to-secondary/50" />
            <div className="w-2 h-2 bg-secondary rotate-45" />
            <div className="w-8 h-0.5 bg-gradient-to-l from-transparent to-secondary/50" />
          </div>
        </div>

        {/* Description */}
        {description && (
          <p
            className={cn(
              "mt-4 text-lg text-muted-foreground max-w-2xl",
              align === "center" && "mx-auto"
            )}
          >
            {description}
          </p>
        )}
      </div>
    </ScrollReveal>
  );
};

export default SectionHeader;
